/* Delegation also supports Shopify Theme Editor section reloads. */
(() => {
  if (window.mctHomepageChatBound) return;
  window.mctHomepageChatBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mct-home [data-mct-chat]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // Only intercept when Crisp is loaded. Otherwise the real link remains usable.
    if (typeof window.$crisp?.is !== 'function') return;
    try {
      window.$crisp.push(['do', 'chat:open']);
      event.preventDefault();
    } catch (_) {
      // Preserve normal navigation if the chat integration is unavailable.
    }
  });
})();
